import { Dialog } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import type { PlanungFeinplanungEditor } from "@/lib/montageplanung";
import { FinePlanningDelegatesSection } from "./FinePlanningDelegatesSection";

export function FinePlanningDelegatesDialog({
  open,
  onClose,
  assignmentId,
  assignmentTitle,
  initialEditors,
  onChanged,
}: {
  open: boolean;
  onClose: () => void;
  assignmentId: number;
  assignmentTitle?: string;
  initialEditors: PlanungFeinplanungEditor[];
  onChanged?: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Feinplanung freigeben"
      description={
        assignmentTitle
          ? `Mitarbeiter für die Feinplanung von „${assignmentTitle}“ auswählen`
          : "Mitarbeiter für die Feinplanung dieses Einsatzes auswählen"
      }
      size="md"
      zIndexClass="z-[220]"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Schließen
        </Button>
      }
      bodyClassName="max-h-[min(70vh,520px)] overflow-y-auto"
    >
      <FinePlanningDelegatesSection
        assignmentId={assignmentId}
        initialEditors={initialEditors}
        onChanged={onChanged}
        compact
      />
    </Dialog>
  );
}
